import React, { FC } from 'react';

const FormDashes = ({ style }) => {
	return (
		<div
			style={{
				overflow: 'hidden',
				display: 'inline-block',
				flex: '0 1 auto',
			}}
		>
			<div
				style={{
					display: 'block',
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'clip',
					...style,
				}}
			>
				{Array.from(Array(1000).keys())
					.map((_) => ' -')
					.join(' ')}
			</div>
		</div>
	);
};

export default FormDashes;
